import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';

const env = import.meta.env;

/**
 * true solo cuando hay un proyecto real configurado en `.env.local`.
 * La app renderiza igual sin esto (login deshabilitado), para poder trabajar
 * la UI sin credenciales.
 */
export const firebaseConfigurado = Boolean(
  env.VITE_FIREBASE_API_KEY && env.VITE_FIREBASE_APP_ID,
);

const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY || 'demo-api-key',
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || 'c3-cien-testing.firebaseapp.com',
  projectId: env.VITE_FIREBASE_PROJECT_ID || 'c3-cien-testing',
  storageBucket:
    env.VITE_FIREBASE_STORAGE_BUCKET || 'c3-cien-testing.firebasestorage.app',
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || '000000000000',
  appId: env.VITE_FIREBASE_APP_ID || '1:000000000000:web:0000000000000000000000',
};

/** Base Firestore con nombre; el proyecto no usa `(default)`. */
const DB_ID = env.VITE_FIRESTORE_DB_ID || 'eventos-cien';

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Cache persistente: la puerta debe leer y escribir sin señal. El SDK encola
// las escrituras y sincroniza sola al reconectar (plan §2 y §5).
export const db = initializeFirestore(
  app,
  { localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }) },
  DB_ID,
);

if (env.VITE_USE_EMULATORS === 'true') {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
  } catch {
    // Ya conectado (recarga en caliente de Vite): sin problema.
  }
}
